export const urls = {
  learnMore:
    'https://support.atlassian.com/bitbucket-cloud/docs/set-up-and-use-custom-merge-checks/',
  exampleApps:
    'https://developer.atlassian.com/platform/forge/example-apps-bitbucket/',
};
